/// <reference path="Text.ts" />

namespace MACRAIL.Forms.Fields {

export class Combo extends Text {

    protected opts: ComboOptions;

    constructor (element: string | JQuery, opts: ComboOptions = {}) {
        super(element, opts);

        if (!this.opts.source) {
            this.opts.source = [];
        }

        this.element.autocomplete({
            'delay': 0,
            'source': this.opts.source,
            'minLength': 0,
            // 'appendTo': this.element.parent(),
            /*open: (event, ui) => {
                this.element.parent().find('.ui-autocomplete').css({
                    width: this.element.parent().width() + 'px'
                });
            },*/
            'select': (event, ui) => {
                this.element.autocomplete('close');

                // Change is not triggered on a scripted update, so manually fire.
                // this.element.trigger('change');
            },
        });

        this.element.on('autocompletechange', (event, ui) => {
            this.element.trigger('change');
        });

        this.element.on('focus', () => {
            this.element.autocomplete('search', '');
        });

        /*this.element.next().on('click', () =>  {
            this.element.trigger('focus');
            this.element.autocomplete('search', '');
        });*/

    }

    public setSource(source: any) {
        this.element.autocomplete('option', 'source', source);
    }

}

interface ComboOptions extends FieldOptions {
    source?: any[];
}

}
